(() => {
document.querySelectorAll('.rp-page .rp-video-play').forEach((button) => {
  button.addEventListener('click', () => {
    const holder = button.closest('[data-video-id]');
    const id = holder.dataset.videoId;
    if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
    if (location.protocol === 'file:') {
      window.open('https://www.youtube.com/watch?v=' + id, '_blank', 'noopener,noreferrer');
      return;
    }
    const player = document.createElement('iframe');
    player.title = 'FTMラジオりょう様によるRISE製品の紹介動画';
    player.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
    player.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    player.allowFullscreen = true;
    player.referrerPolicy = 'strict-origin-when-cross-origin';
    holder.replaceChildren(player);
    player.focus();
  });
});

})();
